export const onlyNumbers = /^[0-9]*$/;
